import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useSignal, useId, $, useContextProvider, Slot } from "@builder.io/qwik";
import { HPopoverRoot } from "../popover/popover-root.qwik.mjs";
import { TooltipContextId } from "./tooltip-context.qwik.mjs";
const HTooltipRoot = component$((props) => {
  const { placement = "top", id, gutter, delayDuration = 0, flip, onOpenChange$, ...rest } = props;
  const triggerRef = useSignal();
  const tooltipState = useSignal("closed");
  const localId = useId();
  const compId = id ?? localId;
  const context = {
    compId,
    localId,
    triggerRef,
    delayDuration,
    state: tooltipState,
    onOpenChange$: $((e) => onOpenChange$?.(e))
  };
  useContextProvider(TooltipContextId, context);
  return /* @__PURE__ */ jsx(HPopoverRoot, {
    manual: true,
    hover: true,
    "bind:anchor": triggerRef,
    floating: placement,
    id: localId,
    gutter,
    flip,
    children: /* @__PURE__ */ jsx("div", {
      id: localId,
      ...rest,
      children: /* @__PURE__ */ jsx(Slot, {})
    })
  });
});
export {
  HTooltipRoot
};
